import { all, takeLatest, put, call, select } from 'redux-saga/effects';

import { apiUpdateUserAttributes } from '../services/apis';
import { updateUserProfileInfo, afterUpdateUserProfile } from './profile';
import * as actions from '../redux/changeSchool';
import {
  getIsProfileCompleted,
  getProfileCompletionMessage,
} from '../redux/profile';
import { actions as errorActions } from '@dragonfruit/redux/error';

export function* changeSchool(action) {
  const { userId, schoolName: newSchoolName, schoolId } = action.payload;
  try {
    const response = yield call(apiUpdateUserAttributes, {
      userId,
      data: {
        school_name: newSchoolName,
        school_id: schoolId,
      },
    });

    yield put(actions.changeSchoolSuccess());
    yield put(actions.changeSchoolComplete());

    const message = newSchoolName
      ? 'account.changeSchoolNewSuccess'
      : 'account.changeSchoolIdSuccess';
    const isProfileCompleted = yield select(getIsProfileCompleted);
    const profileCompletionMessage = yield select(getProfileCompletionMessage);

    yield call(updateUserProfileInfo, response);
    yield afterUpdateUserProfile(
      isProfileCompleted,
      message,
      profileCompletionMessage
    );
  } catch (err) {
    yield put(actions.changeSchoolError(err.message));
    yield put(errorActions.sendError(err));
  }
}

export default function*() {
  yield all([takeLatest(actions.CHANGE_SCHOOL, changeSchool)]);
}



// WEBPACK FOOTER //
// ./app/sagas/changeSchool.js